function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import OptionsModal from "./options_modal";
import SelectedOptions from "./selected_options";
import Button from "./button";
import Checkbox from "./checkbox";
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  ", "\n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);\n  border-radius: 0px 4px 4px 0px;\n  margin-bottom: 10px;\n"])), function (props) {
  return props.hasOptions ? "border-left: 4px solid #008a16; border-left: 4px solid var(--se-primary, #008a16);" : "border-left: 4px solid #9FA0A4;";
});
var PresentationAndArrowWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var ItemPresentationWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 1 0px;\n"])));
var ModuleInformationWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0px;\n"])));
var DescriptionWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-top: 5px;\n  display: flex;\n  flex-wrap: wrap;\n  overflow-x: hidden;\n"])));
var Description = styled.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1 0 calc(50% - 20px);\n  font-weight: 400;\n  font-size: 16px;\n  color: #494b50;\n  margin-right: 30px;\n  margin-top: 5px;\n\n  @media (max-width: ", "px) {\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n    -webkit-box-orient: vertical;\n    display: -webkit-box;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var LinkWrapper = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  font-weight: 700;\n"])));
var AddItemWrapper = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-end;\n  @media (max-width: ", "px) {\n    display: none;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var SlotAndAddWrapper = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 5px;\n"])));
var SlotLabel = styled.span(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n"])));
var SlotWrapper = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var SlotRow = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  font-weight: 400;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 0px 16px;\n\n  border-radius: 2px;\n  border: 1px solid ", ";\n\n  :hover {\n    ", " {\n      text-decoration: underline;\n    }\n  }\n"])), function (props) {
  return props.color ? props.color : '#42B4E6';
}, function (props) {
  return props.color ? props.color : '#42B4E6';
}, SlotLabel);
var SlotIconWrapper = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  margin-right: 5px;\n  width: 24px;\n  height: 24px;\n"])));
var MobileAddOptionsWrapper = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: none;\n  flex: 1 1 0px;\n  justify-content: flex-end;\n\n  @media (max-width: ", "px) {\n      display: flex;\n    }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var MobileAddOptions = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  min-height: 32px;\n  color: ", ";\n  ", "\n"])), function (props) {
  return props.color || '#42B4E6';
}, function (props) {
  return props.disabled ? 'opacity: 0.5; pointer-events: none;' : '';
});
var CheckboxWrapper = styled.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  margin-right: 10px;\n"])));
var Module = /*#__PURE__*/function (_React$Component) {
  _inherits(Module, _React$Component);
  var _super = _createSuper(Module);
  function Module(props) {
    var _this;
    _classCallCheck(this, Module);
    _this = _super.call(this, props);
    /**
     * Checks if any of the modules have an option selected.
     *
     * @returns true if any of the modules have an option selected, false otherwise
     */
    _defineProperty(_assertThisInitialized(_this), "hasSelectedOptions", function () {
      var _mod$selectedOptions, _mod$selectedOptions2;
      var result = false;
      var mod = _this.props.module;
      if (mod.selectedOptions && ((((_mod$selectedOptions = mod.selectedOptions) === null || _mod$selectedOptions === void 0 ? void 0 : _mod$selectedOptions.accessories) || []).length > 0 || (((_mod$selectedOptions2 = mod.selectedOptions) === null || _mod$selectedOptions2 === void 0 ? void 0 : _mod$selectedOptions2.services) || []).length > 0)) {
        result = true;
      }
      return result;
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props$module, _this$props$module$de, _this$props$module$lo2;
      var moduleIdentificationKey = (_this$props$module = _this.props.module) === null || _this$props$module === void 0 ? void 0 : (_this$props$module$de = _this$props$module.deviceIdentification) === null || _this$props$module$de === void 0 ? void 0 : _this$props$module$de.identificationKey;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
        hasOptions: _this.hasSelectedOptions()
      }, /*#__PURE__*/React.createElement(PresentationAndArrowWrapper, null, !_this.props.bulkAccessorize && /*#__PURE__*/React.createElement(CheckboxWrapper, null, /*#__PURE__*/React.createElement(Checkbox, {
        color: _this.props.secondaryColor,
        textColor: _this.props.secondaryTextColor,
        onChange: function onChange(event) {
          event.preventDefault();
          _this.props.onToggleModuleForBulk(moduleIdentificationKey, !_this.props.modulesForBulk.includes(moduleIdentificationKey));
        },
        checked: _this.props.modulesForBulk.includes(moduleIdentificationKey)
      })), /*#__PURE__*/React.createElement(ItemPresentationWrapper, null, /*#__PURE__*/React.createElement(ModuleInformationWrapper, null, /*#__PURE__*/React.createElement(LinkWrapper, null, _this.props.renderProductLink(_this.props.module.id)), /*#__PURE__*/React.createElement(DescriptionWrapper, null, /*#__PURE__*/React.createElement(Description, {
        mobileBreakpoint: _this.props.mobileBreakpoint
      }, _this.props.module.description)), /*#__PURE__*/React.createElement(SlotAndAddWrapper, null, _this.props.module.location && /*#__PURE__*/React.createElement(SlotWrapper, null, /*#__PURE__*/React.createElement(SlotRow, {
        color: _this.props.primaryColor,
        onClick: function onClick() {
          var _this$props$module$lo;
          if ((_this$props$module$lo = _this.props.module.location) !== null && _this$props$module$lo !== void 0 && _this$props$module$lo.onClick) {
            _this.props.module.location.onClick();
          }
        }
      }, /*#__PURE__*/React.createElement(SlotIconWrapper, null, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1024 1024"
      }, /*#__PURE__*/React.createElement("path", {
        fill: "currentColor",
        d: "M511 897c7 0 14-3 20-7l6-7c45-73 90-146 134-220l28-45c39-61 78-124 86-190v-52c-12-140-132-246-273-247-142-3-262 106-274 249v53c8 63 47 126 85 188 10 15 19 29 27 44 39 65 79 130 120 195l16 27c6 8 15 12 25 12zm-3-725h4c117-3 220 90 230 206l1 47c-7 54-44 113-80 170-10 15-19 31-29 46-40 68-82 136-123 203l-5-8c-40-65-81-130-119-195-9-15-18-30-28-45-35-57-72-117-79-168v-48c11-117 110-208 228-208zm4 344c68 0 122-55 122-123s-55-122-122-122h-1c-68 0-123 55-122 123 0 68 55 122 123 122zm0-203c44 0 80 36 80 81 0 44-36 80-80 80s-80-36-81-80c0-44 36-80 80-81h1z"
      }))), /*#__PURE__*/React.createElement(SlotLabel, null, (_this$props$module$lo2 = _this.props.module.location) === null || _this$props$module$lo2 === void 0 ? void 0 : _this$props$module$lo2.label))), _this.props.canAddOptions && /*#__PURE__*/React.createElement(MobileAddOptionsWrapper, {
        mobileBreakpoint: _this.props.mobileBreakpoint
      }, /*#__PURE__*/React.createElement(MobileAddOptions, {
        color: _this.props.primaryColor,
        disabled: _this.props.isSaving,
        onClick: function onClick(event) {
          event.stopPropagation();
          _this.setState({
            modalOpen: true,
            defaultModalActiveCategoryType: null,
            defaultModalAccessoryToView: null,
            defaultOptionTypes: null,
            disablePreviousOnEdit: false
          });
        }
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1024 1024"
      }, /*#__PURE__*/React.createElement("path", {
        fill: "currentColor",
        d: "M783.5,240.6c-149.9-149.9-393.2-149.9-543-0.1c-150.1,150.1-149.8,393.1,0.1,543s392.9,150.1,542.9,0  C933.3,633.7,933.5,390.6,783.5,240.6z M511.9,742c-19,0-34.5-15.4-34.5-34.4c0,0,0-0.1,0-0.1v-161l-160.9,0.1  c-19.1,0-34.6-15.5-34.6-34.5c0.1-19.1,15.5-34.5,34.6-34.6h160.9V316.5c0.3-19.1,16.1-34.3,35.2-34c18.6,0.3,33.7,15.4,34,34v160.9  h160.9c19.1,0,34.6,15.5,34.6,34.6c0,19.1-15.5,34.6-34.6,34.6H546.6v160.9c0.1,19-15.3,34.5-34.3,34.6C512.2,742,512,742,511.9,742  z"
      })))))), _this.props.canAddOptions && /*#__PURE__*/React.createElement(AddItemWrapper, {
        mobileBreakpoint: _this.props.mobileBreakpoint
      }, /*#__PURE__*/React.createElement(Button, {
        id: "".concat(moduleIdentificationKey, "-add-options"),
        icon: 'plus-large',
        disabled: _this.props.isSaving,
        onClick: function onClick(event) {
          event.stopPropagation();
          _this.setState({
            modalOpen: true,
            defaultModalActiveCategoryType: null,
            defaultModalAccessoryToView: null,
            defaultOptionTypes: null,
            disablePreviousOnEdit: false
          });
        },
        label: _this.props.getLabel('options_screen.add_options')
      })))), /*#__PURE__*/React.createElement(SelectedOptions, {
        renderProductLink: _this.props.renderProductLink,
        primaryColor: _this.props.primaryColor,
        primaryTextColor: _this.props.primaryTextColor,
        secondaryColor: _this.props.secondaryColor,
        secondaryTextColor: _this.props.secondaryTextColor,
        isSaving: _this.props.isSaving,
        getLabel: _this.props.getLabel,
        moduleItem: _this.props.module,
        onAddMore: function onAddMore(optionCategory) {
          _this.setState({
            modalOpen: true,
            defaultModalActiveCategoryType: optionCategory,
            defaultModalAccessoryToView: null,
            defaultOptionTypes: null,
            disablePreviousOnEdit: false
          });
        },
        onViewAccessory: function onViewAccessory(optionItem, optionCategory, statusToFilter, disablePreviousOnEdit) {
          _this.setState({
            modalOpen: true,
            defaultModalActiveCategoryType: optionCategory,
            defaultModalAccessoryToView: optionItem,
            defaultOptionTypes: optionItem.optionTypes,
            statusToFilter: statusToFilter,
            disablePreviousOnEdit: disablePreviousOnEdit
          });
        }
      })), _this.state.modalOpen && /*#__PURE__*/React.createElement(OptionsModal, {
        getLabel: _this.props.getLabel,
        getAndReplaceLabel: _this.props.getAndReplaceLabel,
        titleType: _this.props.categoryName,
        moduleId: _this.props.module.id,
        mobileBreakpoint: _this.props.mobileBreakpoint,
        getOptions: function getOptions() {
          return _this.props.module.getOptions();
        },
        imageUrl: _this.props.module.imageUrl,
        primaryColor: _this.props.primaryColor,
        primaryTextColor: _this.props.primaryTextColor,
        secondaryColor: _this.props.secondaryColor,
        secondaryTextColor: _this.props.secondaryTextColor,
        closeModal: function closeModal() {
          _this.setState({
            modalOpen: false,
            defaultModalActiveCategoryType: null,
            defaultModalAccessoryToView: null,
            defaultOptionTypes: null,
            disablePreviousOnEdit: false
          });
        },
        renderProductLink: _this.props.renderProductLink,
        onAddOptions: _this.props.module.onAddOptions,
        onDecreaseOptions: _this.props.module.onDecreaseOptions,
        onRemoveOptions: _this.props.module.onRemoveOptions,
        onAddSubAccessories: _this.props.module.onAddSubAccessories,
        onDecreaseSubAccessories: _this.props.module.onDecreaseSubAccessories,
        onRemoveSubAccessories: _this.props.module.onRemoveSubAccessories,
        deviceIdentification: _this.props.module.deviceIdentification,
        isSaving: _this.props.isSaving,
        defaultActiveCategoryType: _this.state.defaultModalActiveCategoryType,
        defaultModalAccessoryToView: _this.state.defaultModalAccessoryToView,
        defaultOptionTypes: _this.state.defaultOptionTypes,
        statusToFilter: _this.state.statusToFilter,
        disablePreviousOnEdit: _this.state.disablePreviousOnEdit
      }));
    });
    _this.state = {
      modalOpen: false,
      defaultModalActiveCategoryType: null,
      defaultModalAccessoryToView: null,
      defaultOptionTypes: null,
      showOptions: false,
      statusToFilter: null,
      disablePreviousOnEdit: false
    };
    return _this;
  }
  return _createClass(Module);
}(React.Component);
_defineProperty(Module, "propTypes", {
  module: PropTypes.object,
  isSaving: PropTypes.bool,
  renderProductLink: PropTypes.func,
  mobileBreakpoint: PropTypes.number,
  primaryColor: PropTypes.string,
  primaryTextColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  secondaryTextColor: PropTypes.string,
  getLabel: PropTypes.func,
  getAndReplaceLabel: PropTypes.func,
  categoryName: PropTypes.string,
  canAddOptions: PropTypes.bool,
  bulkAccessorize: PropTypes.bool,
  modulesForBulk: PropTypes.array,
  onToggleModuleForBulk: PropTypes.func
});
export default Module;